import { ChannelCalculationMethod } from "store/types";

/**
 * Configuration for channel calculation method features.
 * Each calculation method defines which features it supports.
 */
export interface ChannelCalculationMethodConfig {
    /** Supports compensation groups */
    supportsCompensationGroup: boolean;
    /** Supports showing cumulative sales */
    supportsCumulativeSales: boolean;
    /** Supports alternative milestone amount */
    supportsAlternativeMilestoneAmount: boolean;
    /** Supports milestones */
    supportsHasMilestones: boolean;
    /** Calculation base (type) is editable */
    calculationBaseIsEditable: boolean;
    /** Supports stock display */
    supportsStock: boolean;
}

/**
 * Feature configuration for each calculation method.
 * To add a new calculation method, add its configuration here.
 */
export const CHANNEL_CALCULATION_CONFIG: Record<ChannelCalculationMethod, ChannelCalculationMethodConfig> = {
    [ChannelCalculationMethod.PROPORTIONAL]: {
        supportsCompensationGroup: true,
        supportsCumulativeSales: true,
        supportsAlternativeMilestoneAmount: true,
        supportsHasMilestones: true,
        calculationBaseIsEditable: false,
        supportsStock: true,
    },
    [ChannelCalculationMethod.PACKAGE]: {
        supportsCompensationGroup: false,
        supportsCumulativeSales: false,
        supportsAlternativeMilestoneAmount: false,
        supportsHasMilestones: false,
        calculationBaseIsEditable: false,
        supportsStock: false,
    },
    [ChannelCalculationMethod.SUBSCRIPTION]: {
        supportsCompensationGroup: false,
        supportsCumulativeSales: false,
        supportsAlternativeMilestoneAmount: false,
        supportsHasMilestones: false,
        calculationBaseIsEditable: false,
        supportsStock: false,
    },
};

/**
 * Get the configuration for a specific calculation method.
 */
export const getCalculationMethodConfig = (method: ChannelCalculationMethod): ChannelCalculationMethodConfig => {
    return CHANNEL_CALCULATION_CONFIG[method];
};
